import React, { useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";

import SaveCancel from "../../../components/SaveCancel";
import useSmsTemplate from "../../../hooks/useSmsTemplate";
import TabPanel from "../../../components/TabPanel";
import { a11yProps } from "../../../utils/common";
import SmsTemplateDetail from "./components/SmsTemplateDetail";
import { useFormState, useFormDispatch } from "../../../contexts/SmsTemplateFormContext";
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const initialValues = {
  smsTemplateName: "",
  smsTemplateCode: "",
  content: "",
  status: "ACTIVE",
};

const validationSchema = Yup.object().shape({
  smsTemplateName: Yup.string().required("Required"),
  smsTemplateCode: Yup.string().required("Required"),
  content: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
});

function AddSmsTemplate() {
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const { addSmsTemplate, isSubmitting } = useSmsTemplate();
  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = methods;

  const form = React.useRef();
  const { state } = useFormState();

  const { values: formValues, errors: formErrors } = state.smstemplate;

  console.log(state, "cccccccc");
  const { t } = useTranslation();
  const { hasError, errorMessage } = useSmsTemplate();
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      console.log(data, "datallddd");
      await addSmsTemplate(data);

      dispatch(showSuccessSnackbar("Sms Template added successfully!"));
      navigate("/masters/smstemplate/list");

      reset();
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to add Sms Template"));
    }
  };

  const cancelBtn = () => {
    navigate("/masters/smstemplate/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Master</Typography>
        <Typography>SmsTemplate</Typography>
        <Typography>Add</Typography>
      </Breadcrumbs>
    );
  };

  // const onSubmit = async (data) => {
  //   console.log(data);
  // };

  // const cancelBtn = () => {
  //   navigate("/master/smstemplate/list");
  // };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("add_smstemplate")} subheader={breadCrump()} />
          <CardContent>
            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <SmsTemplateDetail fields={validationSchema.fields} />

                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default AddSmsTemplate;
